import React, { useState } from "react";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import ReCAPTCHA from "react-google-recaptcha";

const Index = ({
  handleSubmit,
  handleChange,
  loading,
  values,
  setStep,
  step,
}) => {
  const [token, setToken] = useState("");
  const siteKey = "6LdTYnknAAAAAEUBgCdOjFC3jEBb6iOldVjBdMCt";

  const handleCaptchaChange = (reCaptchaToken) => setToken(reCaptchaToken);

  const handlePhoneNumberChange = (event) => {
    let input = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    const formattedPhoneNumber =
      input !== "" ? formatPhoneNumber(input) : input;
    const e = {
      target: {
        name: "phone",
        value: formattedPhoneNumber,
      },
    };
    handleChange(e);
  };

  const formatPhoneNumber = (phoneNumber) => {
    const regex = /^(\d{0,3})(\d{0,3})(\d{0,4})$/;
    const parts = phoneNumber.replace(regex, "($1) $2-$3");
    return parts;
  };

  return (
    <div className="w-auto justify-center items-center">
      <p className="text-gray-800 text-center text-3xl font-bold mb-6 mt-5">
        Contact Information
      </p>
      <form
        className="mx-auto max-w-xl"
        onSubmit={(e) => {
          if (token) {
            handleSubmit(e);
          } else {
            e.preventDefault();
            alert("Please verify that you are not a robot.");
          }
        }}
      >
        <div className="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2">
          <div className="relative">
            <label
              htmlFor="first-name"
              className="text-sm font-bold text-green-900 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              First Name*
            </label>
            <input
              type="text"
              name="firstName"
              id="firstName"
              autoComplete="given-name"
              className="w-full px-3.5 py-2 text-gray-800 sm:leading-6 border-green-800 border-2"
              value={values.firstName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="relative">
            <label
              htmlFor="lastName"
              className="text-sm font-bold text-green-900 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              Last Name*
            </label>
            <input
              type="text"
              name="lastName"
              id="lastName"
              required
              autoComplete="family-name"
              className="w-full px-3.5 py-2 text-gray-800 sm:leading-6 border-green-800 border-2"
              onChange={handleChange}
              value={values.lastName}
            />
          </div>
          <div className="relative">
            <label
              htmlFor="email"
              className="text-sm font-bold text-green-900 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              Email Address*
            </label>
            <input
              type="email"
              name="email"
              id="email"
              autoComplete="email"
              className="w-full px-3.5 py-2 text-gray-800 sm:leading-6 border-green-800 border-2"
              onChange={handleChange}
              value={values.email}
              required
            />
          </div>
          <div className="relative">
            <label
              htmlFor="phone"
              className="text-sm font-bold text-green-900 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              Phone Number*
            </label>
            <input
              type="text"
              id="phone"
              name="phone"
              autoComplete="tel"
              placeholder="(___) ___-____"
              className="w-full px-3.5 py-2 text-gray-800 sm:leading-6 border-green-800 border-2 tracking-wider"
              onChange={handlePhoneNumberChange}
              value={values.phone}
              maxLength={14}
              required
            />
          </div>
          <div className="sm:col-span-2">
            <div className="mt-2.5">
              <ReCAPTCHA onChange={handleCaptchaChange} sitekey={siteKey} />
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-900">
            By clicking "Submit" you agree to allow Affordable Debt
            Consolidation to contact you by phone, SMS, or email. We never sell
            your information.
          </p>
          <div className="my-4 flex items-center justify-center">
            <button
              className="bg-white text-green-800 font-bold py-2 rounded-full transition border-green-800 border-4 mr-3 w-40"
              type="button"
              onClick={() => setStep(step - 1)}
            >
              <NavigateBeforeIcon /> Back
            </button>
            <button
              className="bg-green-800 text-white font-bold py-3 w-40 rounded-3xl transition hover:bg-green-900"
              disabled={loading}
              type="submit"
            >
              {loading ? (
                <div className="animate-spin rounded-full border-t-4 border-white h-6 w-6 mx-auto" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Index;
